import { useState } from "react";
import { Collapse } from "@mui/material";
import styled from "styled-components/macro";
import { brightBlue, HUBLET_RAVEN_BLUE } from "../../../constants/colors";
import {
  BREAKPOINT_MOBILE,
  FONT_SIZE_EXTRA_SMALL,
} from "../../../constants/constants";

/** Logic inspired by Flight's show some/all button in the PnL chart */
export const CollapsibleSubRowStyles = styled.div`
  display: flex;
  flex-direction: column;
  font-family: "Open Sans";
  font-weight: 600;

  .btnShowMore {
    color: ${HUBLET_RAVEN_BLUE};
    text-decoration: underline;
    background-color: white;
    border: none;
    cursor: pointer;
    text-align: right;
  }

  .btnShowMore:hover {
    color: ${brightBlue};
    text-decoration: underline;
  }

  .btnShowMore:focus {
    outline: none;
  }

  @media (max-width: ${BREAKPOINT_MOBILE}px) {
    .btnShowMore {
      font-size: ${FONT_SIZE_EXTRA_SMALL - 2}px;
    }
  }
`;

export default function CollapsibleSubRows({
  subRows,
  showMoreTitle,
  showLessTitle,
}: {
  subRows: any[];
  showMoreTitle: string;
  showLessTitle: string;
}) {
  const [isShowMoreExpanded, setIsShowMoreExpanded] = useState(false);
  const toggleShowMore = () => setIsShowMoreExpanded(!isShowMoreExpanded);

  return (
    <CollapsibleSubRowStyles>
      <Collapse in={isShowMoreExpanded}>{subRows}</Collapse>
      <button className="btnShowMore" onClick={toggleShowMore}>
        {isShowMoreExpanded ? showLessTitle : showMoreTitle}
      </button>
    </CollapsibleSubRowStyles>
  );
}
